var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8727 75.6701H16.0327C15.4616 75.6747 14.8961 75.557 14.3743 75.3249C13.8525 75.0928 13.3864 74.7516 13.0074 74.3243C12.6285 73.8971 12.3454 73.3936 12.1773 72.8478C12.0091 72.302 11.9598 71.7265 12.0327 71.1601L28.0327 18.1601C28.1573 17.1899 28.6332 16.299 29.3703 15.6559C30.1074 15.0128 31.0545 14.6621 32.0327 14.6701H35.7527C36.74 14.6638 37.6947 15.0229 38.4332 15.6783C39.1716 16.3337 39.6416 17.239 39.7527 18.2201L54.8527 71.1701C54.9237 71.7341 54.8737 72.3067 54.7061 72.8499C54.5384 73.3931 54.2569 73.8943 53.8803 74.3201C53.5037 74.7459 53.0406 75.0865 52.522 75.3193C52.0034 75.5521 51.4411 75.6717 50.8727 75.6701Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0322 13.18L65.2322 5",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5122 29.1698C27.8822 31.3698 40.3422 31.5798 43.1722 28.7998",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2822 40.3901C26.8822 44.3901 44.6522 42.7401 46.6222 40.3901",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0723 51.48C23.4223 56.48 48.9123 53.93 50.5823 51.48",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 63.5002C18.6224 66.8902 47.5024 67.1302 54.6824 62.9102",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5423 19.67C32.3646 20.0521 35.224 20.0756 38.0523 19.74C38.3509 19.7018 38.6362 19.5931 38.8846 19.4229C39.1331 19.2528 39.3375 19.026 39.481 18.7613C39.6246 18.4967 39.7032 18.2017 39.7104 17.9007C39.7175 17.5996 39.6531 17.3012 39.5223 17.03L37.2523 12.33C37.075 11.981 36.8046 11.6879 36.471 11.4832C36.1374 11.2785 35.7537 11.1701 35.3623 11.17H32.3623C31.9662 11.1661 31.577 11.2738 31.2392 11.4807C30.9014 11.6876 30.6287 11.9854 30.4523 12.34L28.1123 17C27.9876 17.2664 27.9268 17.5582 27.9348 17.8522C27.9427 18.1461 28.0191 18.4342 28.158 18.6935C28.2968 18.9527 28.4943 19.176 28.7346 19.3455C28.9749 19.5151 29.2515 19.6262 29.5423 19.67V19.67Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7524 19.48C39.5024 20.15 68.5224 23.64 68.5224 23.64",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSense);
export default __webpack_public_path__ + "static/media/icon-sense.53fd4d87c5598e1d8bb5a4d288d607cf.svg";
export { ForwardRef as ReactComponent };